<template>
 <div>
    <div v-if="widgetState=='display' & mode=='big'">
        <div class="panel-container">
            <div v-if="pageListPtr > 0" class="left-arrow scroll-button" @click="backScroll()">
                <!-- <img :src="backimage"/> -->
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path fill="gray" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
                </svg>
            </div>
            <div v-else class="left-arrow scroll-button">
              &nbsp;
            </div>
            <div class="panel-grid">
                <div class="product-panel" v-for="(fmlproduct,index) in pageList[pageListPtr].products" :key="index">
                    <product-panel 
                        :product="fmlproduct" 
                        fmlCtrl="true" 
                        :highlight="highlight" 
                        :eventSource="eventSource"
                        sbButtonText="Find Similar" 
                        :design="design"
                        @findMore="findMore" >
                    </product-panel>
                </div>
            </div>
            <div v-if="scroll=='true' && moreProducts" class="right-arrow scroll-button" @click="frontScroll()">
                <!-- <img :src="moreimage"/> -->
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path fill="gray" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                </svg>
            </div>
        </div>
    </div>
    <div v-else>
    </div>
    <div v-if="widgetState=='display' & mode=='small'" class="icon-panel">
        <h4 class="small-header">Cart Companion Products</h4>
        <div class="icon-grid" @click="expandIcons()">
            <div class="small-image" v-for="(product,index) in pageList[pageListPtr].products" :key="index">
                <img :src="product.image">
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ProductPanel from './ProductPanel'
// import SB from '../sbcore/sbsdk.js'

let site = require(process.env.VUE_APP_SITE_JS)

export default {
  components : {ProductPanel},
  props : {
    'productid' : String,
    'showseed' : String,
    'design' : Object,
    'number' : {
      type : Number,
      default : 4
    },
    'productlist' : {
      type : String,
      default : ""
    },
    'scroll' : {
      type : String,
      default : "true"
    },
    'highlight' : {
      type : String,
      default : "false"
    },
    'type' : {
      type : String,
      default : "overlay"
    },
    'mode' : {
      type : String,
      default : 'big'
    },
    sb : Object
  },
  data: () => ({
    seedProduct : null,
    seedProductid : null,
    pageList : [],
    pageListPtr : 0,
    imagesURL : site.imagesURL,
    screenNumber : null,
    displayReady : false,
    eventSource : 'cross-sell_unknown',
    viewedPage : 0,
    widgetState : 'hide'
  }),
  methods : {
    expandIcons : function () {
      this.$emit('updateMode','big')

      let data = {
      'sbAction' : 'Expand',
      'productid' : "",
      'source' : this.eventSource,
      'page' : window.location.pathname+window.location.search
      }
      this.sb.sendEvent('sbaction',data)
    },
    findMore: function (args) {
      this.getSimilar(args.product) //,true)
    },
    frontScroll : function (){
      // this.getSimilar(this.seedProduct) //,true)
      if (this.pageListPtr < this.pageList.length-1) {
        this.pageListPtr = this.pageListPtr + 1
      }
    },
    backScroll: function () {
      this.pageListPtr = Math.max(this.pageListPtr-1,0)
    },
    getCrossSell : function () {

      // Reduce the number asked for if the screen is narrow. This will work down to 2 for a 
      // mobile screen of 320px
      this.screenNumber = Math.min(this.number,Math.floor(window.innerWidth / 160))

      // this.sb = new SB()
      // this.sb.init()
      this.eventSource = 'cross-sell_'+this.type

      // Convert the productlist string into an array
      // Remove blank ones, which can be caused by trailing commas
      const productList = this.productlist.split(',').filter(x=>x != '')

      this.viewedPage = this.viewedPage + 1
      this.sb.getCrossSellProducts(productList,this.number,(pids) => {
        if (pids.length==0) {
          this.widgetState = (this.pageList.length==0) ? 'noproducts' : 'nomore'
          this.viewedExhausted = true
        } else {
          let ps = []
          let rejects = 0
          for (let pid of pids) {
            this.sb.getProductObject(pid,(product)=>{
              // Check for products no longer existing
              if (Object.keys(product).length === 0) {
                rejects = rejects+1
              } else {
                if (ps.length < this.number) {ps.splice(0,0,product)}
                // if (ps.length < this.number) {ps.push(product)}
              }
              if (ps.length+rejects == Math.min(this.number,(pids.length))) {
                // Viewed always get pushed to the start of the list, as they are History
                // this.pageList.push({type:'viewed',products:ps}) 
                let sbAction = ''
                if (ps.length > 0) {
                  this.pageList.splice(0,0,{type:'viewed',products:ps}) //.slice(0)
                  this.pageListPtr = 0
                  this.widgetState = 'display'
                  sbAction = 'Display'
            
                } else if (this.pageList.length == 0 ) {
                  this.widgetState = 'noproducts'
                  sbAction = 'Display-NoProducts'
                } else {
                  this.widgetState = 'nomore'
                  sbAction = 'Display-NoMore'
                }
                let data = {
                  'sbAction' : sbAction,
                  'productid' : "",
                  'source' : this.eventSource,
                  'page' : window.location.pathname+window.location.search
                  }
                  this.sb.sendEvent('sbaction',data)
              }
            })
          }
        }
      })
    },
 

    getSimilar(product) {

        let excludeHistory = (this.pageListPtr==0) ? false : true; 

        this.sb.getSimilarProducts(product,this.screenNumber,excludeHistory,false,((slist) => {
        let ps = []
        for (let s of slist) {
          this.sb.getProductObject(s,(p)=>{
            ps.push(p)
            if (ps.length == slist.length) {
              //
              // Find Sim needs to be at the end of the list so delete findsims forward of it
              // Otherwise the findsim results get mixed up and it becomes confusing
              for (let i=this.pageList.length-1;i>this.pageListPtr;i=i-1) {
                if (this.pageList[i].type=='findsim') {
                  this.pageList.splice(i,1)
                }
              }
              this.pageList.push({type:'findsim',products : ps}) //.slice(0)
              this.pageListPtr = this.pageList.length - 1
              // this.history = hlist
            }
          })
        }
        }))    
      }



  },
  mounted () {
    this.getCrossSell()
  },
  computed : {
    moreimage : function (){return this.imagesURL+"arrow-right.svg"},
    backimage : function (){return this.imagesURL+"arrow-left.svg"},
    panelWidth : function () {
      return this.sb.panelWidth(85,this.screenNumber)
    },
    moreProducts : function () {
      return (this.pageListPtr < this.pageList.length - 1)
    },
  },
  watch : {
    widgetState : function () {
      this.$emit('updateWidgetState',this.widgetState)
    }

  }
};
</script>
<style scoped>
/*
.hpanels {
  display : inline-flex;
  flex-shrink: 1;
  justify-content: space-around;
}

.small-image img {
  width : 64px;
  height : 64px;
}

.scroll-button {
  cursor : pointer;
  display : flex;
  -ms-align-items: center;
  align-items: center;
}

.scroll-button svg {
  border : 1px solid gray;
  border-radius : 5px;
}

.scroll-button:hover svg {
      background-color: #E30613;
      border-color: #E30613;
}

.scroll-button:hover svg path {
  fill : white;
}

.hpanels .product-panel {
  width : 30%;
}

.small-header {
  padding-left : 10px;
  padding-right : 10px;
  margin : 0;
  font-family: GillSansforJL, Arial;
}

.grid-container {
  display : grid;
  grid-template-columns: 1fr repeat(3, 3fr) 1fr;
  justify-items : center;
  column-gap: 50px;
}
*/

/*.panel-container {
    border : 2px red solid;          
    background-color: white ;      
    display : grid;
    grid-template-columns: 30px auto 30px;
    grid-template-areas: 
      "leftside | . panels rightside";
}*/
/*
.panel-grid {
    grid-area : panels;
}

.left-arrow {
  grid-area : leftside;
}

.right-arrow {
  gris-area : rightside;
}

*/

.scroll-button {
  cursor : pointer;
  display : flex;
  -ms-align-items: center;
  align-items: center;
}


.scroll-button svg {
  border : 1px solid gray;
  border-radius : 50%;
}

.scroll-button:hover svg {
      background-color: var(--controls-color);
      border-color: var(--controls-color);
}

.scroll-button:hover svg path {
  fill : white;
}

h4 {
  padding : 5px;
  text-align:   center;
  margin : 5px;
}

.panel-container {
    /*border : var(--border)   ;*/
    /*background-color: var(--background-color) ;      */
    display : grid;
    grid-template-columns: 40px auto 40px;
    grid-template-areas: 
      "leftside panels rightside";
    align-items: center;
    column-gap : 50px;
}

.panel-grid {
    grid-area : panels;
    display : grid;
    grid-template-columns: repeat(var(--number),auto);
    grid-column-gap: 50px;
}

.left-arrow {
  grid-area : leftside;
}

.right-arrow {
  grid-area : rightside;
}

.icon-grid {
  /*border : var(--border);*/
  cursor : pointer;
  width : min-content;
  display : grid;
  /*grid-template-columns: repeat(var(--number), auto);     /* number */
  grid-template-columns: var(--icon-columns);   
  grid-template-rows : 1fr;

}

.icon-grid img {
  width : var(--icon-width);
  height : var(--icon-height);
}

.icon-panel {
  display : grid;
  grid-template-columns : 1fr;
  justify-items: center;
}

</style>